/**
 * This status could be used in the following way (it appears in many different contexts):
 * cannot complete the user action of cancelling the tradeplan, bc the user is currently in a position
 * {
	"messageType": "alertNotification",
	"notificationId": 1645464499401,
	"notificationDetails": {"errorType":"USER_ACTION","notificationType":"ERROR","userAction":"CANCEL","userActionDetails":null,"TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "IN_POSITION",
	"statusDetails": {"symbol":"XYx"},
	"date": "2022-02-21T12:28:20.364-0500",
	"timestamp": "1645464500364"
}

 * @param {*} statusDetails 
 * @returns an object with fields:
 * 1) symbol: the symbol of the position that is causing this status
 */
export function inPositionParser(statusDetails) {
  const parsedObj = {
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.positionSymbol ?? null;
  }

  return parsedObj;
}
